import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import rFaaliyetAlaniListesi from '../../models/rFaaliyetAlaniListesi';
import rList from '../../models/rList';

export default class FaaliyetAlaniListesiApi extends ApiBase<pList, rList<rFaaliyetAlaniListesi>> {
    constructor(options?: Options) {
        super(
            new MethodInfo({
                MethodUrl: '/FaaliyetAlaniListesi',
            }),
            options
        );
    }
}
